import React from 'react';
import Context from './context'
// import MyCal from './MyCal'
import MyCal from './datetimeCal'
import MyButton from './myButton'
import { Combobox } from 'evergreen-ui'
import Link from '@material-ui/core/Link';
import { Checkbox, Icon, Popup, Button } from 'semantic-ui-react'
import { OPERATIONAL_HOURS_SCHEDULE_AR } from '../utils/operationalHours'
import { IS_TEST_VERSION, TEST_VERSION_BANNER_AR } from '../utils/version'


class ExeForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }


    componentDidMount() {

    }

    render() {
        return (
            <Context.Consumer>
                {
                    // ctx.value == state
                    ctx => {
                        return (

                            <div className="colf">
                                {IS_TEST_VERSION && (
                                    <div style={{
                                        margin: "5px 5px 10px 10px",
                                        padding: "10px 12px",
                                        background: 'repeating-linear-gradient(45deg, #b91c1c, #b91c1c 10px, #991b1b 10px, #991b1b 20px)',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                        textAlign: 'center',
                                        direction: 'rtl',
                                        borderRadius: '6px',
                                        border: '2px solid #7f1d1d',
                                        lineHeight: 1.5,
                                        fontFamily: 'Cairo, sans-serif'
                                    }}>
                                        {TEST_VERSION_BANNER_AR}
                                    </div>
                                )}

                                <div className="dtp-card" style={{ direction: 'rtl' }}>
                                    <div className="dtp-card-title">
                                        <Icon name="calendar alternate outline" /> الفترة الزمنية
                                    </div>

                                    <MyCal label="من" val={ctx.value.fromDateVal} onChangeMethod={ctx.actions.fromDateOnChange} />
                                    <MyCal label="إلى" val={ctx.value.toDateVal} onChangeMethod={ctx.actions.toDateOnChange} />

                                    <div className="dtp-presets">
                                        {(() => {
                                            const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
                                            const endOfDay = (d) => { const x = new Date(d); x.setHours(23, 59, 59, 999); return x; };
                                            const today = new Date();
                                            const yesterday = new Date(today); yesterday.setDate(today.getDate() - 1);
                                            const sevenAgo = new Date(today); sevenAgo.setDate(today.getDate() - 6);
                                            const thirtyAgo = new Date(today); thirtyAgo.setDate(today.getDate() - 29);
                                            const monthStart = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);
                                            const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1, 0, 0, 0, 0);
                                            const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999);
                                            const presets = [
                                                { k: 'today', label: 'اليوم', from: startOfDay(today), to: endOfDay(today) },
                                                { k: 'yesterday', label: 'أمس', from: startOfDay(yesterday), to: endOfDay(yesterday) },
                                                { k: '7d', label: 'آخر 7 أيام', from: startOfDay(sevenAgo), to: endOfDay(today) },
                                                { k: '30d', label: 'آخر 30 يوم', from: startOfDay(thirtyAgo), to: endOfDay(today) },
                                                { k: 'mtd', label: 'هذا الشهر', from: monthStart, to: endOfDay(today) },
                                                { k: 'lastm', label: 'الشهر الماضي', from: lastMonthStart, to: lastMonthEnd },
                                            ];
                                            return presets.map(p => (
                                                <button
                                                    key={p.k}
                                                    type="button"
                                                    className="dtp-chip"
                                                    onClick={() => ctx.actions.setDateRange(p.from, p.to)}
                                                >
                                                    {p.label}
                                                </button>
                                            ));
                                        })()}
                                    </div>
                                </div>

                                <div className="combo_container">


                                    <div style={{ margin: "5px 5px 10px 10px" }}>
                                        <Combobox
                                            key={`acc-${ctx.value.selectedReportNew?.id || 0}`}
                                            className="Aligner-item"

                                            items={ctx.value.reports}
                                            initialSelectedItem={ctx.value.selectedReportNew || ctx.value.reports[0]}
                                            onChange={selected => ctx.actions.onAccountChange(selected)}
                                            placeholder="Accounts"
                                            itemToString={item => item ? item.title : ''}
                                            autocompleteProps={{
                                                title: 'بحث'
                                            }}
                                        />
                                    </div>


                                    <div  style={{ margin: "5px 5px 10px 10px",display: "none" }}>
                                        <Combobox
                                            className="Aligner-item"

                                            items={ctx.value.targetTypes}
                                            initialSelectedItem={ctx.value.targetTypes[0]}//{ctx.value.targetTypes[1]}
                                            onChange={selected => ctx.actions.onTargetTypeChange(selected)}
                                            placeholder="Target Types"
                                            itemToString={item => item ? item.title : ''}
                                            autocompleteProps={{
                                                title: 'بحث'
                                            }}
                                        />
                                    </div>

                                    <div style={{ margin: "5px 5px 10px 10px" }}>
                                        <Combobox
                                            className="Aligner-item"

                                            items={ctx.value.sources}
                                            initialSelectedItem={ctx.value.sources[0]}//{ctx.value.targetTypes[1]}
                                            onChange={selected => ctx.actions.onSourceChange(selected)}
                                            placeholder="Source"
                                            itemToString={item => item ? item.title : ''}
                                            autocompleteProps={{
                                                title: 'بحث'
                                            }}
                                        />
                                    </div>

                                    <div style={{ margin: "5px 5px 10px 10px" }}>
                                        <Combobox
                                            className="Aligner-item"

                                            items={ctx.value.destinations}
                                            initialSelectedItem={ctx.value.destinations[0]}//{ctx.value.targetTypes[1]}
                                            onChange={selected => ctx.actions.onDestinationChange(selected)}
                                            placeholder="Destination"
                                            itemToString={item => item ? item.title : ''}
                                            autocompleteProps={{
                                                title: 'بحث'
                                            }}
                                        />
                                    </div>

                                    {(() => {
                                        const isNahrawan = ctx.value.selectedDestination?.id === 2;
                                        const isLocked = ctx.value.isReady && !ctx.value.unlockOpHoursToggle;
                                        const toggleDisabled = !isNahrawan || isLocked;
                                        const schedule = OPERATIONAL_HOURS_SCHEDULE_AR;
                                        return (
                                            <div style={{
                                                margin: "5px 5px 10px 10px",
                                                padding: "10px 12px",
                                                width: "240px",
                                                boxSizing: "border-box",
                                                background: "#f9fafb",
                                                border: "1px solid #e5e7eb",
                                                borderRadius: "6px",
                                                direction: "rtl",
                                                textAlign: "right",
                                                position: "relative",
                                                zIndex: 0,
                                                isolation: "isolate"
                                            }}>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                    <Checkbox
                                                        toggle
                                                        disabled={toggleDisabled}
                                                        checked={ctx.value.filterByOperationalHours}
                                                        onChange={ctx.actions.toggleOperationalHoursFilter}
                                                    />
                                                    <span style={{ fontSize: "0.9em", flex: 1, lineHeight: 1.3 }}>
                                                        فلتر ساعات العمل في طمر النهروان
                                                    </span>
                                                    <Popup
                                                        trigger={<Icon name="info circle" link color="blue" style={{ margin: 0 }} />}
                                                        on="click"
                                                        position="top center"
                                                        wide
                                                        content={
                                                            <div style={{ direction: 'rtl', textAlign: 'right', lineHeight: 1.8, minWidth: 260 }}>
                                                                <b>{schedule.title}</b>
                                                                {schedule.lines.map((ln, i) => (
                                                                    <div key={i}>{ln}</div>
                                                                ))}
                                                                <hr style={{ margin: '8px 0' }} />
                                                                <small>{schedule.footer}</small>
                                                            </div>
                                                        }
                                                    />
                                                </div>
                                                {!isNahrawan && (
                                                    <div style={{ color: '#6b7280', fontSize: '0.78em', marginTop: '6px' }}>
                                                        متاح فقط لطمر النهروان
                                                    </div>
                                                )}
                                                {isNahrawan && isLocked && (
                                                    <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                                                        <span style={{ color: '#d97706', fontSize: '0.78em' }}>
                                                            مقفل بعد التنفيذ
                                                        </span>
                                                        <Button size="mini" basic compact onClick={ctx.actions.requestUnlockOpHoursToggle}>
                                                            <Icon name="lock open" /> فتح للتعديل
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })()}

                                    {/* {ctx.value.selectedTargetType.id === 0 ?
                                    <div style={{ margin: "5px 5px 10px 10px" }}>
                                        <Combobox
                                            className="Aligner-item"

                                            items={ctx.value.units ? ctx.value.units : []}
                                            initialSelectedItem={ctx.value.units ? ctx.value.units[0] : {}}
                                            onChange={selected => ctx.actions.onUnitChange(selected)}
                                            placeholder="اختر مركبة"
                                            itemToString={item => item ? item.$$user_name : ''}
                                            autocompleteProps={{
                                                title: 'بحث'
                                            }}
                                        />
                                    </div>
                                    :
                                    null

                                }

                                {
                                    ctx.value.selectedTargetType.id === 1 ? */}
                                    <div style={{ margin: "5px 5px 10px 10px" }}>
                                        <Combobox
                                            key={`grp-${ctx.value.selectedObject?.$$user_name || (ctx.value.unitGroups && ctx.value.unitGroups[0] && ctx.value.unitGroups[0].$$user_name) || 'none'}`}
                                            className="Aligner-item"
                                            items={ctx.value.unitGroups ? ctx.value.unitGroups : []}
                                            initialSelectedItem={ctx.value.selectedObject || (ctx.value.unitGroups ? ctx.value.unitGroups[0] : null)}
                                            onChange={selected => ctx.actions.onUnitGroupChange(selected)}
                                            placeholder="اختر مجموعة"
                                            itemToString={item => item ? item.$$user_name : ''}
                                            autocompleteProps={{
                                                title: 'بحث'
                                            }}
                                        />
                                    </div>
                                    {/* :
                                        null
                                } */}
                                    {
                                        ctx.value.zones.length > 0 ?
                                            <div style={{ margin: "5px 5px 10px 10px" }}>
                                                <Combobox
                                                    className="Aligner-item"
                                                    key={item => item ? item.id : -1}
                                                    items={ctx.value.filteredZones ? ctx.value.filteredZones : []}
                                                    initialSelectedItem={ctx.value.filteredZones ? ctx.value.filteredZones[0] : null}
                                                    onChange={selected => ctx.actions.onZoneChange(selected)}
                                                    placeholder="اختر المنطقة"
                                                    itemToString={item => item ? item.n : ''}
                                                    autocompleteProps={{
                                                        title: 'بحث'
                                                    }}
                                                />
                                            </div>
                                            :
                                            null
                                    }


                                </div>
                                <MyButton whenClick={ctx.actions.execute} label="تنفيذ"></MyButton>
                                {
                                    // <MyButton whenClick={ctx.actions.export} label="تصدير"></MyButton>

                                    ctx.value.isReady && ctx.value.allowExport?
                                        <MyButton whenClick={ctx.actions.export} label="تصدير"></MyButton>
                                        :
                                        null
                                }
                                {/* <div style={{ backgroundColor: "#2F5596" }}>

                                    <img src={"../../assets/img/wenklogo.png"} style={{
                                        display: "block",
                                        margin: "auto",
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)'
                                    }} />
                                </div> */}
                            </div>

                        )
                    }
                }
            </Context.Consumer >
        )
    }
}

export default ExeForm;